import { gql } from '@/shared/graphql/generated/cache';

export const getOperatorInfoQuery = gql(/* GraphQL */ `
  query OperatorInfo($idSs58: String!) {
    auction: auctionById(id: 1) {
      minActiveBid
    }
    operator: operatorByIdSs58(idSs58: $idSs58) {
      exceptionList
      openDelegationEnabled
      activeDelegationFeeBps
      upcomingDelegationFeeBps
      account: accountByIdSs58 {
        alias
      }
      delegators: delegationsByOperatorIdSs58 {
        nodes {
          upcomingAmount
          activeAmount
          idSs58: delegatorIdSs58
        }
      }
      validators: operatorValidatorsByOperatorIdSs58 {
        nodes {
          validator: validatorByValidatorIdSs58 {
            ...CacheValidator
          }
        }
      }
    }
  }
`);

export const getValidatorsByIds = gql(/* GraphQL */ `
  query ValidatorsByIds($ids: [String!]!) {
    validators: allValidators(filter: { idSs58: { in: $ids } }) {
      nodes {
        ...CacheValidator
      }
    }
  }
`);

export const getAllOperators = gql(/* GraphQL */ `
  query AllOperators($operators: [String!]) {
    auction: auctionById(id: 1) {
      minActiveBid
      blockReward
      endBlockNumber
      currentHeight
      activeBond
    }
    upcomingAuthorities: allValidators(filter: { upcomingApyBp: { greaterThan: 0 } }) {
      totalCount
    }
    currentAuthorities: allValidators(filter: { apyBp: { greaterThan: 0 } }) {
      totalCount
    }
    operators: allOperators(filter: { idSs58: { in: $operators } }) {
      nodes {
        idSs58
        activeDelegationFeeBps
        upcomingDelegationFeeBps
        openDelegationEnabled
        exceptionList
        account: accountByIdSs58 {
          alias
        }
        currentDelegators: delegationsByOperatorIdSs58(
          filter: { activeAmount: { greaterThan: "0" } }
        ) {
          nodes {
            delegatorIdSs58
          }
        }
        upcomingAuthorities: operatorValidatorsByOperatorIdSs58(
          filter: { validatorByValidatorIdSs58: { upcomingApyBp: { greaterThan: 0 } } }
        ) {
          totalCount
          aggregates {
            sum {
              upcomingAmount
            }
          }
        }
        upcomingDelegatingValidators: operatorValidatorsByOperatorIdSs58(
          filter: {
            validatorByValidatorIdSs58: {
              upcomingApyBp: { isNull: true }
              isQualified: { equalTo: true }
            }
          }
        ) {
          totalCount
          aggregates {
            sum {
              upcomingAmount
            }
          }
        }
        currentAuthorities: operatorValidatorsByOperatorIdSs58(
          filter: { validatorByValidatorIdSs58: { apyBp: { greaterThan: 0 } } }
        ) {
          totalCount
          aggregates {
            sum {
              activeAmount
            }
          }
        }
        allValidators: operatorValidatorsByOperatorIdSs58 {
          totalCount
          aggregates {
            sum {
              bond
              totalBalance
            }
          }
        }
        qualifiedValidators: operatorValidatorsByOperatorIdSs58(
          filter: { validatorByValidatorIdSs58: { isQualified: { equalTo: true } } }
        ) {
          totalCount
        }
        onlineValidators: operatorValidatorsByOperatorIdSs58(
          filter: { validatorByValidatorIdSs58: { isOnline: { equalTo: true } } }
        ) {
          totalCount
        }
        delegations: delegationsByOperatorIdSs58 {
          nodes {
            delegatorIdSs58
            upcomingAmount
            activeAmount
          }
          aggregates {
            sum {
              upcomingAmount
              activeAmount
            }
          }
        }
      }
    }
  }
`);
